import * as React from "react";
import { useDialog } from "@shared-ui/dialog-context";
import { observer } from "mobx-react";
import { CampaignRecommendationsWithOffersQuery } from "../../../../../../__generated__/api";
import Price = CampaignRecommendationsWithOffersQuery.Price;
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { InfoDialog } from "../../Common/InfoDialog/InfoDialog";
import { useLocalization } from "@shared-ui/localization-context";

export const DestinationOfferPriceInfo = observer(
  ({
    scrimDisplay,
    offerPrice,
    cardIndex,
    campaignId,
  }: {
    scrimDisplay: boolean;
    offerPrice: Price;
    cardIndex: number;
    campaignId: string;
  }) => {
    const valueClass = scrimDisplay
      ? "all-l-margin-one uitk-type-heading-500 cardContent"
      : "all-l-margin-one uitk-type-heading-600 ";
    const qualifierClass = scrimDisplay
      ? "all-l-margin-one uitk-type-paragraph-200 cardContent"
      : "all-l-margin-one uitk-type-100 ";
    const prefixClass = qualifierClass;

    const { formatText } = useLocalization();
    const [, dialogActions, DestinationOfferDialogComponent] = useDialog(`disclaimer-info-${campaignId}-${cardIndex}`);

    return (
      <div className="DestinationOfferPriceInfo">
        {offerPrice.prefixText && <div className={prefixClass}>{offerPrice.prefixText}</div>}
        {offerPrice.disclaimerText && (
          <button className="disclaimerInfoIcon" onClick={dialogActions.openDialog}>
            <UitkIcon
              name="info_outline"
              size={UitkIconSize.SMALL}
              id={`disclaimer-info-${campaignId}-${cardIndex}`}
              title={formatText("merchCampaign.disclaimerIcon.title")}
            />
          </button>
        )}
        <span className={valueClass}>{offerPrice.value}</span>
        <div className={qualifierClass}>{offerPrice.qualifierText}</div>
        {offerPrice.disclaimerText && (
          <DestinationOfferDialogComponent>
            <InfoDialog
              infoText={offerPrice.disclaimerText}
              closeDialog={dialogActions.closeDialog}
              buttonText={formatText("DestinationsByAffinity.priceDialogCloseButton")}
            />
          </DestinationOfferDialogComponent>
        )}
      </div>
    );
  }
);
